import { TicketAccess } from "./TicketAccess";

export interface BasketItem {
  facilityIds: string; //ustawiam id'ki obiektu
  facilityName: string;
  facilityStreet: string;
  facilityLocality: string;
  pictureUrl: string;
  description: string;
  assortIds: string; //ustawiam id'ki asortymentu
  assortName: string;
  qnt: number; //ustawiam qnt
  price: number;
  listPrice: number;
  minSale: number;
  maxSale: number;
  validFrom: string;
  ticketAccess: TicketAccess[]; //ustawiam liste imprez
}

export const setBasketItem = (facilityIds: string, assortIds: string, ticketAccess: TicketAccess[]): BasketItem => {
  return {
    facilityIds,
    assortIds,
    ticketAccess,
    qnt: 1
  } as BasketItem;
};
